var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconUser = function SvgIconUser(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B0B5C4",
    d: "M4.594 5.869c1.334 0 2.416-1.314 2.416-2.935C7.01 1.314 6.655 0 4.594 0c-2.06 0-2.416 1.314-2.416 2.934 0 1.621 1.082 2.935 2.416 2.935z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M.064 10.398c0-.194-.002-.054 0 0zM9.19 10.437c.003-.03 0-.21 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0B5C4",
    d: "M9.152 10.23c-.045-2.822-.413-3.627-3.235-4.136 0 0-.397.506-1.323.506-.925 0-1.323-.506-1.323-.506C.481 6.598.09 7.39.038 10.139c-.004.225-.006.236-.007.21v.297S.704 12 4.595 12c3.891 0 4.563-1.354 4.563-1.354v-.22c0 .017-.002-.015-.005-.195z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-user.59bffa7c.svg";
export { ForwardRef as ReactComponent };